import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Value from '~/views/Home/base/Value';
import Run from './Run';
import chunk from 'lodash.chunk';
import oget from 'oget';

export default
class CurrentScoresScored extends Component {
    static propTypes = {
        athleteLive: PropTypes.object.isRequired,
        t: PropTypes.func.isRequired,
    }

    render() {
        const {
            athleteLive,
            t,
            colors: {
              headerScores
            }
        } = this.props;

        const runs = chunk(
            oget(
                athleteLive,
                'details.Runs.values',
                []
            ).slice(0, 10),
            6
        );

        const runsLabel = oget(
            athleteLive,
            'details.Runs.label',
            'Runs'
        )

        const tricks = oget(
            athleteLive,
            'details.Tricks.values',
            []
        );

        const tricksLabel = oget(
            athleteLive,
            'details.Tricks.label',
            []
        );

        return (
            <div className="bottom-scores">
                <div className="section">
                    <div className="label-container">
                        <span className="scores label">
                            {t('Scores')}
                        </span>
                    </div>
                </div>

                <div className="section section-runs">
                    <div className="label-container">
                        <span className="label">
                            {t(runsLabel)}
                        </span>
                    </div>

                    <div className="data-runs">
                        {Array.isArray(runs[0]) &&
                            <div className="runs">
                                {runs[0]
                                .map((run, i) => (
                                    <Run
                                        key={`header_run_0_${i}`}
                                        run={run}
                                        scoreBox={headerScores.scoreBox}
                                        scoreBoxHighlight={headerScores.scoreBoxHighlight}
                                        scoreBoxDrop={headerScores.scoreBoxDrop}
                                    />
                                ))}

                                {!tricks.length && Array.isArray(runs[1]) &&
                                    runs[1]
                                    .map((run, i) => (
                                        <Run
                                            key={`header_run_1_${i}`}
                                            run={run}
                                            scoreBox={headerScores.scoreBox}
                                            scoreBoxHighlight={headerScores.scoreBoxHighlight}
                                            scoreBoxDrop={headerScores.scoreBoxDrop}
                                        />
                                    ))
                                }
                            </div>
                        }

                        {!!tricks.length && Array.isArray(runs[1]) &&
                            <div className="runs">
                                {runs[1]
                                .map((run, i) => (
                                    <Run
                                        key={`header_run_2_${i}`}
                                        run={run}
                                        scoreBox={headerScores.scoreBox}
                                        scoreBoxHighlight={headerScores.scoreBoxHighlight}
                                        scoreBoxDrop={headerScores.scoreBoxDrop}
                                    />
                                ))}
                            </div>
                        }
                    </div>
                </div>

                {!!tricks.length &&
                    <div className="section section-tricks">
                        <div className="label-container">
                            <span className="label">
                                {t(tricksLabel)}
                            </span>
                        </div>

                        <div className="data">
                            {tricks
                            .map((trick, i) => {
                                let style = trick.highlight
                                    ? headerScores.scoreBoxHighlight
                                    : headerScores.scoreBox;

                                if (trick.drop) {
                                    style = headerScores.scoreBoxDrop;
                                }

                                return (
                                    <div
                                        key={`header_trick_${i}`}
                                        style={style}
                                    >
                                        <Value>{trick.rank}</Value>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/header/HeaderScores/CurrentScoresScored.js